import React from "react";
import { useEffect } from "react";
import { withAuthProvider } from "../auth";
import { initTrackingContext, initTracking } from "./tracking";
import { jobsBySalesforceContactId } from "../../queries";
import { GraphQLQuery } from "../../features/common/functions/graphql";
import { initIndex } from "../algolia";

const buildCustomAlgoliaQuery = ({
  queryParams,
  created,
  hitsPerPage = 10,
}) => {
  return {
    hitsPerPage,
    page: 0,
    attributesToRetrieve: [
      "jobId",
      "jobTitle",
      "created",
      "facilities",
      "job_category",
      "base_compensation_min",
      "current_step",
      "applicant_group",
      "offices",
      "facilities",
      "job_category",
      "employment_type",
      "years_experience",
      "submission_deadline",
      "base_compensation_max",
      "additional_pga_education",
      "pay_schedule",
      "education",
      "apply_via",
      "experience_required",
    ],
    responseFields: "*",
    filters: `(annual_compensation_min.value >= 0.00 OR annual_compensation_max.value >= 0.00) AND submission_deadline > ${Date.now() / 1000} AND (current_step:"complete" OR current_step:"Complete")`,
  };
};

const buildSingleAlgoliaQuery = (Id) => {
  return {
    hitsPerPage: 150,
    page: 0,
    attributesToRetrieve: [
      "jobId",
      "jobTitle",
      "created",
      "facilities",
      "job_category",
      "base_compensation_min",
      "current_step",
      "applicant_group",
      "offices",
      "facilities",
      "job_category",
      "employment_type",
      "years_experience",
      "submission_deadline",
      "base_compensation",
      "base_compensation_max",
      "additional_pga_education",
      "pay_schedule",
      "education",
      "apply_via",
      "experience_required",
    ],
    responseFields: "*",
    filters: `jobId: "${Id}"`,
  };
};

export const getAllJobs = async () => {
  const jobsIndex = initIndex(
    process.env.REACT_APP_ALGOLIA_APP_ID,
    process.env.REACT_APP_ALGOLIA_API_KEY,
    process.env.REACT_APP_ALGOLIA_INDEX_NAME,
  );

  const algoliaQuery = buildCustomAlgoliaQuery({
    queryParams: {},
    hitsPerPage: 150,
  });
  const { hits: allJobs } = algoliaQuery
    ? await jobsIndex.search(algoliaQuery)
    : [];

  return allJobs;
};

export const getSingleJob = async (jobId) => {
  const jobsIndex = initIndex(
    process.env.REACT_APP_ALGOLIA_APP_ID,
    process.env.REACT_APP_ALGOLIA_API_KEY,
    process.env.REACT_APP_ALGOLIA_INDEX_NAME,
  );

  const algoliaQuery = buildSingleAlgoliaQuery(jobId);
  const { hits: singleJob } = algoliaQuery
    ? await jobsIndex.search(algoliaQuery)
    : [];

  return singleJob;
};

const SegmentWrapperInner = ({ isLoggedIn, me, contactId, jobsData }) => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const userData =
      isLoggedIn && me
        ? {
            id: me.externalId || me.id,
            ...me,
          }
        : null;

    initTrackingContext({
      user: userData,
      isLoggedIn,
      jobsData: jobsData,
    });

    if (isLoggedIn && userData && window.analytics) {
      window.analytics.identify(userData.id, userData);
    } else if (window.analytics) {
      window.analytics.reset();
    }

    // Add a small delay to ensure OneTrust has a chance to load first
    const initTimeout = setTimeout(() => {
      try {
        initTracking();
      } catch (error) {
        console.error("Error initializing tracking:", error);
      }
    }, 1000); // 1 second delay

    return () => {
      clearTimeout(initTimeout);
    };
  }, [isLoggedIn, me, jobsData, contactId]);
  return null;
};

const SegmentWrapper = (props) => {
  const { isLoggedIn, me, contactId } = props;

  // Don't execute GraphQL query if user is not logged in.
  if (!isLoggedIn) {
    return (
      <SegmentWrapperInner
        isLoggedIn={isLoggedIn}
        me={me}
        contactId={contactId}
        jobsData={null}
      />
    );
  }

  return (
    <GraphQLQuery
      query={jobsBySalesforceContactId}
      variables={{
        input: {
          contactId: contactId || (me && me.salesforceId),
        },
      }}
    >
      {({ data: jobsData }) => (
        <SegmentWrapperInner
          isLoggedIn={isLoggedIn}
          me={me}
          contactId={contactId}
          jobsData={jobsData}
        />
      )}
    </GraphQLQuery>
  );
};

export default withAuthProvider(SegmentWrapper);
